import * as PDFLib from 'pdf-lib'

const PDF_VERSION = '1.2' // increment the version when the PDF template changes to invalidate browser caches
const PDF_TEMPLATE_FILE = '../voucher/voucher.pdf'

const currentScriptSrc = document.currentScript.src // this works only outside function scope

/**
 * Generates and downloads a voucher PDF with the given code and subtext.
 * @param voucherCode {string} the voucher code to be inserted into the PDF
 * @param voucherSubtext {string} the subtext to be inserted into the PDF
 */
/* eslint-disable-next-line no-unused-vars */
const suiDownloadVoucher = async (voucherCode, voucherSubtext) => {
  const baseUrl = new URL('.', currentScriptSrc)
  const pdfTemplateUrl = new URL(PDF_TEMPLATE_FILE, baseUrl).href
  const arrayBuffer = await fetch(`${pdfTemplateUrl}?v=${PDF_VERSION}`).then((res) => res.arrayBuffer())
  const pdfDoc = await PDFLib.PDFDocument.load(arrayBuffer)

  const Font = {
    REGULAR: PDFLib.StandardFonts.Helvetica,
    BOLD: PDFLib.StandardFonts.HelveticaBold,
  }

  const getColorRgb = (r, g, b) => PDFLib.rgb(r / 255, g / 255, b / 255)

  const drawText = async (text, textSize, posY, font) => {
    const page = pdfDoc.getPages()[0]
    const embeddedFont = await pdfDoc.embedFont(font)
    const textWidth = embeddedFont.widthOfTextAtSize(text, textSize)
    const centerX = page.getSize().width / 2 - textWidth / 2
    const suiColorNight = getColorRgb(40, 40, 80)

    page.drawText(text, {
      x: centerX,
      y: posY,
      size: textSize,
      font: embeddedFont,
      color: suiColorNight,
    })
  }

  const drawVoucherCode = async () => {
    await drawText(voucherCode, 35, 598, Font.BOLD)
  }

  const drawVoucherSubtext = async () => {
    await drawText(voucherSubtext, 9, 573, Font.REGULAR)
  }

  await drawVoucherCode()
  await drawVoucherSubtext()

  const pdfBytes = await pdfDoc.save()

  const startPdfDownload = () => {
    const blob = new Blob([pdfBytes], { type: 'application/pdf' })
    const a = document.createElement('a')
    a.href = URL.createObjectURL(blob)
    a.setAttribute('download', 'smartsteuer-Gutschein.pdf')
    a.click()
  }

  startPdfDownload()
}
